jQuery(function ($) {
  let country_code = '';
  let country_name = '';
  var productAmazonHomeByCountry = {
    GB: 'https://www.amazon.co.uk/stores/page/4EFC153A-0371-48D9-B947-9A828BA1EDC0?aref=33veQ4mT8u',
    FR: 'https://www.amazon.fr/-/en/stores/medicube/page/8FDE7826-EC48-4E33-A826-79908DF9BC30?lp_asin=B0GS8YKMN3&ref_=ast_bln&store_ref=bl_ast_dp_brandlogo_sto',
    DE: 'https://www.amazon.de/-/en/stores/medicube/page/B7FBB8FA-D0CF-480A-A1B4-873364C79F2B?lp_asin=B0GS8YKMN3&ref_=ast_bln&store_ref=bl_ast_dp_brandlogo_sto&bl_grd_status=override',
    ES: 'https://www.amazon.es/-/en/stores/medicube/page/9B11B1CD-C61C-4AA4-9A03-F8C55228F017?lp_asin=B0GS8YKMN3&ref_=ast_bln&store_ref=bl_ast_dp_brandlogo_sto&bl_grd_status=override',
    IT: 'https://www.amazon.it/-/en/stores/medicube/page/6D138F79-DC00-45E0-97C1-C37856765F26?lp_asin=B0GS8YKMN3&ref_=ast_bln&store_ref=bl_ast_dp_brandlogo_sto'
  };
  var productAmazonDetailByHandle = {
    'booster-pro-x2': {
      GB: 'https://www.amazon.co.uk/dp/B0GS8YKMN3',
      IT: 'https://www.amazon.it/dp/B0GS8YKMN3',
      FR: 'https://www.amazon.fr/dp/B0GS8YKMN3',
      ES: 'https://www.amazon.es/dp/B0GS8YKMN3',
      DE: 'https://www.amazon.de/dp/B0GS8YKMN3',
      NL: 'https://www.amazon.nl/dp/B0GS8YKMN3'
    }
  };
  var localStoreTestCountry = new URLSearchParams(window.location.search).get('test_country');
  var localePathByCountry = {
    DE: '/de-de',
    FR: '/fr-de',
    IT: '/it-de',
    NL: '/nl-de',
    ES: '/es-de'
  };
  var localePathPrefixes = Object.keys(localePathByCountry)
    .map(function (countryCode) {
      return localePathByCountry[countryCode];
    })
    .filter(function (path, index, paths) {
      return paths.indexOf(path) === index;
    })
    .concat(['/pt-br', '/da', '/es', '/nb', '/sv-se', '/de', '/fr', '/el', '/it', '/nl', '/pt-pt'])
    .sort(function (a, b) {
      return b.length - a.length;
    });
  var localizedMarketLocales = ['en-de', 'de-de', 'fr-de', 'it-de', 'nl-de', 'es-de'];
  var currentMarketLocale = (window.location.pathname.split('/')[1] || '').toLowerCase();

  function localizeInternalLink(anchor) {
    if (localizedMarketLocales.indexOf(currentMarketLocale) === -1 || currentMarketLocale === 'en-de') return;

    var href = anchor.getAttribute('href');
    if (!href || href.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/i.test(href)) return;

    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (error) {
      return;
    }

    if (url.origin !== window.location.origin) return;

    var localePattern = /^\/(?:en-de|de-de|fr-de|it-de|nl-de|es-de)(?=\/|$)/;
    var localizableRoutePattern = /^\/(?:collections|products|pages|search|blogs|cart|account|policies)(?=\/|$)/;

    if (localePattern.test(url.pathname)) {
      url.pathname = url.pathname.replace(localePattern, '/' + currentMarketLocale);
    } else if (localizableRoutePattern.test(url.pathname)) {
      url.pathname = '/' + currentMarketLocale + url.pathname;
    } else {
      return;
    }

    if (localStoreTestCountry) {
      url.searchParams.set('test_country', localStoreTestCountry.toUpperCase());
    }

    anchor.setAttribute('href', url.pathname + url.search + url.hash);
  }

  function localizeInternalLinks(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;

    if (root.nodeType === 1 && root.matches('a[href]')) {
      localizeInternalLink(root);
    }

    root.querySelectorAll('a[href]').forEach(localizeInternalLink);
  }

  localizeInternalLinks(document);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        localizeInternalLinks(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  function redirectToCountryLocale(selectedCountryCode) {
    var localePath = localePathByCountry[(selectedCountryCode || '').toUpperCase()];
    if (!localePath) return false;

    var currentPath = window.location.pathname || '/';
    if (currentPath === localePath || currentPath.indexOf(localePath + '/') === 0) return false;
    var hasExplicitAmazonLocale = Object.keys(localePathByCountry).some(function (countryCode) {
      var countryPath = localePathByCountry[countryCode];
      return currentPath === countryPath || currentPath.indexOf(countryPath + '/') === 0;
    });
    if (hasExplicitAmazonLocale) return false;

    var pathWithoutLocale = currentPath;
    localePathPrefixes.some(function (prefix) {
      if (pathWithoutLocale === prefix) {
        pathWithoutLocale = '/';
        return true;
      }

      if (pathWithoutLocale.indexOf(prefix + '/') === 0) {
        pathWithoutLocale = pathWithoutLocale.slice(prefix.length) || '/';
        return true;
      }

      return false;
    });

    var nextPath = localePath + (pathWithoutLocale === '/' ? '' : pathWithoutLocale);
    window.location.replace(nextPath + window.location.search + window.location.hash);
    return true;
  }
  var localStoreTestCountryNames = {
    JP: 'Japan',
    KR: 'South Korea',
    MY: 'Malaysia',
    SG: 'Singapore',
    VN: 'Vietnam',
    US: 'United States',
    BR: 'Brazil',
    AU: 'Australia',
    CA: 'Canada',
    DK: 'Denmark',
    FR: 'France',
    DE: 'Germany',
    NL: 'Netherlands',
    MX: 'Mexico',
    NO: 'Norway',
    PL: 'Poland',
    ES: 'Spain',
    IT: 'Italy',
    SE: 'Sweden',
    CH: 'Switzerland',
    GB: 'United Kingdom',
    AE: 'United Arab Emirates',
    EZ: 'Eurozone'
  };
  var localStoreCountryMeta = {
    US: { currency: 'USD', flag: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/7f0109d94c888a663452af48e2d324d7.svg' },
    KR: { currency: 'KRW', flag: 'https://cdn.shopify.com/static/images/flags/kr.svg' },
    BR: { currency: 'BRL', flag: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/190073fb7652e7c635a1b91af0286b3c.svg' },
    AU: { currency: 'AUD', flag: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/d4e9cde3edb3e1732ec50170e158d750.svg' },
    CA: { currency: 'CAD', flag: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/422898ab4299eb270f856e6c1b8d2250.svg' },
    DK: { currency: 'DKK', flag: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/e60c493fdbe69069d943ecc37287aa90.svg' },
    MX: { currency: 'MXN', flag: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/2bcda95713919c2134876a7da635da80.svg' },
    NO: { currency: 'NOK', flag: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/d8dd9ad33e2d0c876096fbdfd87bcf31.svg' },
    PL: { currency: 'PLN', flag: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/965125896e906dc4ccbf65fa398c386c.svg' },
    SE: { currency: 'SEK', flag: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/637920f30b717c7f4e826a4bb63bb552.svg' },
    CH: { currency: 'CHF', flag: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/a5d4c82835e435ecff150a9a3426fed2.svg' },
    GB: { currency: 'GBP', flag: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/f9bbc4885a348eff84e4ef4155121fae.svg' },
    AE: { currency: 'AED', flag: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/62a4257f72ece1437bc8eb7f0535327b.svg' },
    EZ: { currency: 'EUR', flag: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/9886b4168efb1ebf48006093aa9807c5.svg' },
    AT: { currency: 'EUR', flag: 'https://cdn.shopify.com/static/images/flags/at.svg' },
    BE: { currency: 'EUR', flag: 'https://cdn.shopify.com/static/images/flags/be.svg' },
    DE: { currency: 'EUR', flag: 'https://cdn.shopify.com/static/images/flags/de.svg' },
    FI: { currency: 'EUR', flag: 'https://cdn.shopify.com/static/images/flags/fi.svg' },
    FR: { currency: 'EUR', flag: 'https://cdn.shopify.com/static/images/flags/fr.svg' },
    GR: { currency: 'EUR', flag: 'https://cdn.shopify.com/static/images/flags/gr.svg' },
    IE: { currency: 'EUR', flag: 'https://cdn.shopify.com/static/images/flags/ie.svg' },
    IT: { currency: 'EUR', flag: 'https://cdn.shopify.com/static/images/flags/it.svg' },
    NL: { currency: 'EUR', flag: 'https://cdn.shopify.com/static/images/flags/nl.svg' },
    PT: { currency: 'EUR', flag: 'https://cdn.shopify.com/static/images/flags/pt.svg' },
    ES: { currency: 'EUR', flag: 'https://cdn.shopify.com/static/images/flags/es.svg' },
    NZ: { currency: 'NZD', flag: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/cacb9f87701ae2707676064d036a97b2.svg' }
  };

  function updateLocationPopupCountry(selectedCountryCode, selectedCountryName) {
    var meta = localStoreCountryMeta[selectedCountryCode] || localStoreCountryMeta.US;
    var selectedStoreCountryCode = window.Shopify && window.Shopify.country;
    var displayCountryCode = selectedStoreCountryCode && selectedStoreCountryCode !== 'EZ'
      ? selectedStoreCountryCode
      : selectedCountryCode;
    var displayMeta = localStoreCountryMeta[displayCountryCode] || meta;
    var locationCountryName = localStoreTestCountryNames[selectedCountryCode] || selectedCountryName || selectedCountryCode;
    $('.cur_loca_name').text(locationCountryName);
    $('.loca_name').text(locationCountryName);
    $('.flag_icon').html('<img src="' + displayMeta.flag + '" alt="national flag icon"/>');
    $('.loca_currency').html(displayMeta.currency);
    $('#pop_cont1 .recommendation-modal__selector--flag').each(function () {
      if ($(this).find('option[value="' + displayCountryCode + '"]').length) {
        $(this).val(displayCountryCode);
      }
    });
    $('.hide').hide();
    $('.aviation_warn li.common_warn').show();
    $('.aviation_warn li.us_warn.hide').toggle(selectedCountryCode == 'US');
    $('.aviation_warn li.mx_warn.hide').toggle(selectedCountryCode == 'MX');
    $('.aviation_warn li.sp_warn.hide').toggle(selectedCountryCode == 'ES');
    if (selectedCountryCode == 'US' || selectedCountryCode == 'CA') {
      $('.aviation_warn li.common_warn').hide();
    }
  }

  function updateProductAmazonButton(selectedCountryCode) {
    selectedCountryCode = (selectedCountryCode || '').toUpperCase();
    if (!selectedCountryCode) return;

    var productHandle = window.location.pathname.split('/products/')[1];
    if (productHandle) {
      productHandle = productHandle.split('/')[0].split('?')[0];
    }
    var detailUrl = productAmazonDetailByHandle[productHandle] && productAmazonDetailByHandle[productHandle][selectedCountryCode];
    var amazonUrl = detailUrl || productAmazonHomeByCountry[selectedCountryCode];
    if (!amazonUrl) return;

    $('product-form .product-form__submit[name="add"]').each(function () {
      var $button = $(this);
      var buttonId = $button.attr('id');
      var buttonClass = $button.attr('class');
      var buttonText = 'Shop on Amazon';

      var $amazonButton = $('<a></a>')
        .attr('href', amazonUrl)
        .attr('target', '_blank')
        .attr('rel', 'noopener noreferrer')
        .attr('aria-label', buttonText)
        .attr('data-amazon-country', selectedCountryCode)
        .attr('data-product-handle', productHandle)
        .css({
          backgroundColor: '#FF6002',
          borderRadius: '100px',
          color: '#fff',
          height: '52px',
          minHeight: '52px',
          padding: '0',
          gap: '5px',
          justifyContent: 'center',
          fontWeight: '500',
          letterSpacing: 'normal'
        })
        .addClass(buttonClass)
        .addClass('local-store-product-amazon-button')
        .html('Shop on<img src="https://cdn.shopify.com/s/files/1/0156/3905/2336/files/amazon_btn_wh.png?v=1789085049" alt="Amazon" style="display:inline-block;width:62px;margin-top:7px;">');

      if (buttonId) {
        $amazonButton.attr('id', buttonId);
      }

      $button.replaceWith($amazonButton);
    });

    $('product-form .shopify-payment-button').hide();
  }

  $(document).on(
    'click',
    '.local-store-product-amazon-button[data-product-handle="booster-pro-x2"]',
    function () {
      var $button = $(this);
      var amazonCountryByHost = {
        'www.amazon.co.uk': 'gb',
        'www.amazon.fr': 'fr',
        'www.amazon.de': 'de',
        'www.amazon.es': 'es',
        'www.amazon.it': 'it',
        'www.amazon.nl': 'nl'
      };
      var amazonHost = '';

      try {
        amazonHost = new URL($button.attr('href')).hostname.toLowerCase();
      } catch (error) {
        amazonHost = '';
      }

      var amazonCountry = amazonCountryByHost[amazonHost]
        || ($button.attr('data-amazon-country') || '').toLowerCase();

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'booster_pro_x2_amazon_click_' + amazonCountry,
        product_handle: 'booster-pro-x2',
        product_name: 'Booster Pro X2',
        amazon_country: amazonCountry.toUpperCase(),
        amazon_url: $button.attr('href'),
        button_location: $button.closest('.device_fixed_wrap').length ? 'sticky' : 'product_detail'
      });
    }
  );

  function getAmazonCountryCode(detectedCountryCode) {
    var localeCountryByPath = {
      fr: 'FR',
      'fr-de': 'FR',
      de: 'DE',
      'de-de': 'DE',
      es: 'ES',
      'es-de': 'ES',
      it: 'IT',
      'it-de': 'IT',
      nl: 'NL',
      'nl-de': 'NL'
    };
    var locale = (window.location.pathname.split('/')[1] || '').toLowerCase();
    var selectedStoreCountryCode = window.Shopify && window.Shopify.country
      ? window.Shopify.country.toUpperCase()
      : '';

    if (localStoreTestCountry) {
      return localStoreTestCountry.toUpperCase();
    }

    return localeCountryByPath[locale]
      || (selectedStoreCountryCode && selectedStoreCountryCode !== 'EZ' ? selectedStoreCountryCode : '')
      || detectedCountryCode;
  }

  function applyDetectedCountry(detectedCountryCode, detectedCountryName) {
    country_code = detectedCountryCode;
    country_name = detectedCountryName;
    var locationCountryName = localStoreTestCountryNames[country_code] || country_name || country_code;

    console.log('country_code' + country_code);
    if (redirectToCountryLocale(country_code)) return;

    updateLocationPopupCountry(country_code, locationCountryName);
    updateProductAmazonButton(getAmazonCountryCode(country_code));

    if(country_code  == 'US'){
      $('.aviation_warn li:last-child').text('In Virgin a, Puerto Rico, Alaska, Guam, Hawaii, only 4 devices can be shipped by air.');
    }if(country_code  == 'MX'){
      $('.aviation_warn').html('<li>Shop in MXN</li><li>Less than $300USD</li><li>Only 4 devices can be shipped by air.</li>');
    }
    if(country_code != 'BR' &&country_code != 'AU'&&country_code != 'CA'&&country_code != 'DK'&&country_code != 'MX'&&country_code != 'NO'&&country_code != 'PL'&&country_code != 'SE'&&country_code != 'CH'&&country_code != 'GB'&&country_code != 'UA'&&country_code != 'EZ'){
      $('.cur_loca_name').text(locationCountryName);
      $('.loca_name').text(locationCountryName);
    }
  }

  if (localStoreTestCountry) {
    applyDetectedCountry(
      localStoreTestCountry.toUpperCase(),
      localStoreTestCountryNames[localStoreTestCountry.toUpperCase()] || localStoreTestCountry.toUpperCase()
    );
  } else {
    fetch(
      window.Shopify.routes.root
        + 'browsing_context_suggestions.json'
        + '?country[enabled]=true'
        + `&country[exclude]=${window.Shopify.country}`
        + '&language[enabled]=true'
        + `&language[exclude]=${window.Shopify.language}`
    ).then(r => r.json())
    .then(res=> {
      applyDetectedCountry(res.detected_values.country.handle, res.detected_values.country_name);
      /*if(country_code == 'KR' ){
        $('#cur_location.on').css('display','none');
        }
          */
    });
  }

  $('#cur_location_content > .recommendation-modal__button--minimal').click(function(){
    $('#pop_cont1').hide();
    $(this).hide();
    $('#pop_cont2').show(); 
  });
   $('.loca_pop_close').click(function(){
  
  });

var locaPopup = function() {
  $("#cur_location").on("click", ".loca_pop_close", function () {
    $("#cur_location").removeClass("on");
  });
$("#cur_location").removeClass("on");
  $('.Header__CurrencySelector').click(function(){
    if($("#cur_location").hasClass('on')){
      $("#cur_location").removeClass('on');
    }else{
      
    $("#cur_location").addClass("on");
    }
      
  });

}

$(function() {
  locaPopup();
});
 });
 
